// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tj3qnpxsCSjmm8AE7ELr {
  max-height: 100%;
  overflow-y: auto;
}

.weilOjC7jviKlP2YGM6N {
  position: relative;

  padding: 16px 10px 17px 10px;
  cursor: pointer;
  border-radius: 24px;
  margin-bottom: 4px;
}

.r_fSBSZ1Y8QBaypaICye {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.weilOjC7jviKlP2YGM6N:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .transItem:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.weilOjC7jviKlP2YGM6N::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 0.7px;
  bottom: -2px;
  right: 0;
  background: rgba(116, 116, 128, 1);
  opacity: 0.15;
}

.uu0mZFxUzkx6G2XUTMUJ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nWbfTcMBEC09pWtDOmYI {
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  /* background: #007AFF; */
  font-size: 18px;
  font-weight: 760;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.QuuJaiw3tEdQh4bl6kyB {
  font-size: 16px;
  font-weight: 560;
  margin-bottom: 2px;
}

@media (max-width: 350px) {
  .QuuJaiw3tEdQh4bl6kyB {
    font-size: 15px;
  }
  .P6QMzebaqsOEvAb_f6Cj {
    font-size: 13.5px;
  }
  .IIM1Kf8RHQQloGWiZhDy {
    font-size: 14px;
  }
  .IFRjfrEo6fPboKsm7jRG {
    padding: 14px;
  }
}

@media (max-width: 330px) {
  .weilOjC7jviKlP2YGM6N {
    padding: 14px 7px 14px 7px;
  }
  .nWbfTcMBEC09pWtDOmYI {
    font-size: 16px;
    min-width: 35px;
    min-height: 35px;
    max-width: 35px;
    max-height: 35px;
  }
}

.P6QMzebaqsOEvAb_f6Cj {
  font-size: 13.5px;
  color: #8E8E93;
}

.IIM1Kf8RHQQloGWiZhDy {
  color: #34C759;
  text-align: right;
  font-size: 16.5px;
  font-weight: 540;
}

@media (max-width: 380px) {
  .QuuJaiw3tEdQh4bl6kyB {
    font-size: 15px;
  }
  .IIM1Kf8RHQQloGWiZhDy {
    font-size: 15px;
  }
  .P6QMzebaqsOEvAb_f6Cj {
    font-size: 13px;
    color: #8E8E93;
  }
}

.DFrRSFXH2bQwfozap2Pj {
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  font-size: 23px;
  font-weight: 540;
}

.IFRjfrEo6fPboKsm7jRG {
  padding: 16px;
  border-radius: 24px;
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/main/history/history.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB","sourcesContent":[".transItems {\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.transItem {\n  position: relative;\n\n  padding: 16px 10px 17px 10px;\n  cursor: pointer;\n  border-radius: 24px;\n  margin-bottom: 4px;\n}\n\n.transItemTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.transItem:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .transItem:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.transItem::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 0.7px;\n  bottom: -2px;\n  right: 0;\n  background: rgba(116, 116, 128, 1);\n  opacity: 0.15;\n}\n\n.transItemLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.transItemLogo {\n  min-width: 40px;\n  min-height: 40px;\n  max-width: 40px;\n  max-height: 40px;\n  border-radius: 50%;\n  /* background: #007AFF; */\n  font-size: 18px;\n  font-weight: 760;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transItemLeftStatus {\n  font-size: 16px;\n  font-weight: 560;\n  margin-bottom: 2px;\n}\n\n@media (max-width: 350px) {\n  .transItemLeftStatus {\n    font-size: 15px;\n  }\n  .transItemLeftFrom {\n    font-size: 13.5px;\n  }\n  .transItemRight {\n    font-size: 14px;\n  }\n  .historyWrapper {\n    padding: 14px;\n  }\n}\n\n@media (max-width: 330px) {\n  .transItem {\n    padding: 14px 7px 14px 7px;\n  }\n  .transItemLogo {\n    font-size: 16px;\n    min-width: 35px;\n    min-height: 35px;\n    max-width: 35px;\n    max-height: 35px;\n  }\n}\n\n.transItemLeftFrom {\n  font-size: 13.5px;\n  color: #8E8E93;\n}\n\n.transItemRight {\n  color: #34C759;\n  text-align: right;\n  font-size: 16.5px;\n  font-weight: 540;\n}\n\n@media (max-width: 380px) {\n  .transItemLeftStatus {\n    font-size: 15px;\n  }\n  .transItemRight {\n    font-size: 15px;\n  }\n  .transItemLeftFrom {\n    font-size: 13px;\n    color: #8E8E93;\n  }\n}\n\n.historyEmpty {\n  height: 10vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  font-size: 23px;\n  font-weight: 540;\n}\n\n.historyWrapper {\n  padding: 16px;\n  border-radius: 24px;\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transItems": `Tj3qnpxsCSjmm8AE7ELr`,
	"transItem": `weilOjC7jviKlP2YGM6N`,
	"transItemTop": `r_fSBSZ1Y8QBaypaICye`,
	"transItemLeft": `uu0mZFxUzkx6G2XUTMUJ`,
	"transItemLogo": `nWbfTcMBEC09pWtDOmYI`,
	"transItemLeftStatus": `QuuJaiw3tEdQh4bl6kyB`,
	"transItemLeftFrom": `P6QMzebaqsOEvAb_f6Cj`,
	"transItemRight": `IIM1Kf8RHQQloGWiZhDy`,
	"historyWrapper": `IFRjfrEo6fPboKsm7jRG`,
	"historyEmpty": `DFrRSFXH2bQwfozap2Pj`
};
export default ___CSS_LOADER_EXPORT___;
